export function pushResponseMessage(message, success = true, doesNotExpire = false) {
  const responseMessage = useState('responseMessage');

  responseMessage.value.message = message;
  responseMessage.value.success = success;
  responseMessage.value.isAdminOnly = false;
  responseMessage.value.doesNotExpire = doesNotExpire;
  responseMessage.value.key++;
}